import { DeleteIcon, EditIcon, ResourceMenuActions, type ResourceMenuItem } from '@all-manager/design-system-v2';
import ConfirmDeleteDialog from '../../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import type { PendingItemWithProvider } from '../../../../../types';
import { usePendingItemMenuActions } from './usePendingItemMenuActions';

// Keeps the French quotes and question mark on the title's line.
const NBSP = '\u00a0';

type Props = {
  item: PendingItemWithProvider;
  onEdit: () => void;
  onDelete: () => void | Promise<unknown>;
};

export default function PendingItemMenuActions(props: Props) {
  const hook = usePendingItemMenuActions(props);

  const actions: (ResourceMenuItem | null | undefined | false)[] = [
    {
      id: 'edit',
      label: 'Modifier',
      icon: <EditIcon fontSize="small" />,
      onClick: hook.handleEditClick,
    },
    { type: 'divider', id: 'divider' },
    {
      id: 'delete',
      label: 'Supprimer',
      icon: <DeleteIcon fontSize="small" color="error" />,
      onClick: hook.handleDeleteClick,
    },
  ];

  return (
    <>
      <ResourceMenuActions actions={actions} tooltip={`Options de l'élément ${props.item.title}`} />

      {hook.isDeleteModalOpen ? (
        <ConfirmDeleteDialog
          title="Supprimer l'élément à suivre"
          onConfirm={hook.handleConfirmDelete}
          onClose={hook.handleDeleteModalClose}
        >
          Supprimer l'élément à suivre «{NBSP}{props.item.title}{NBSP}»{NBSP}?
        </ConfirmDeleteDialog>
      ) : null}
    </>
  );
}

export { PendingItemMenuActions };
